export default __webpack_public_path__ + "static/media/dot.ca0c4b07.svg";